import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { iacOptionInterface } from 'src/app/page_component_item/input-with-autocomplete/input-with-autocomplete.component';
import { genericFormInterface } from 'src/app/util/interfaces/genericForm';
import { LabelsService } from 'src/app/util/services/labels/labels.service';
import { DotBounceLoadingEffectModule } from 'src/app/page_component_item/dot-bounce-loading-effect/dot-bounce-loading-effect.module';
import { GenericFormGenModule } from 'src/app/page_component_item/generic-form-gen/generic-form-gen.module';
import { InputWithAutocompleteModule } from 'src/app/page_component_item/input-with-autocomplete/input-with-autocomplete.module';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { CommonModule } from '@angular/common';
import { LabelsInterface } from 'src/app/util/services/labels/data/label.inteface';

@Component({
	standalone: true,
	selector: 'pcp-search-filter',
	templateUrl: './search-filter.component.html',
	styleUrls: ['./search-filter.component.scss'],
	imports: [CommonModule, DotBounceLoadingEffectModule, GenericFormGenModule, InputWithAutocompleteModule, FaIconComponent],
})
export class SearchFilterComponent implements OnInit {
	icons = {
		faTimes: faTimes,
	};

	labels: LabelsInterface = {
		lbl_filtros_de_busca: '',
		lbl_nenhum_filtro_selecionado: '',
		lbl_geral_selecione: '',
		lbl_adicionar_filtros_personalizados: '',
		lbl_geral_nao: '',
		lbl_geral_sim: '',
	};

	@Output()
	getFiltersIAC = new EventEmitter();
	@Output()
	getFilterGeneric = new EventEmitter();
	@Output()
	newTag = new EventEmitter();

	constructor(private LabelsService: LabelsService) {}

	isLoadingLabels = true;
	isLoadingFilters = true;
	isFirstRun = true;

	@Input()
	titleLabel = 'no_title_label_selected';
	@Input()
	tipLabel = 'no_tip_label_selected';

	@Input()
	availableFiltersIAC: iacOptionInterface[] = [];

	@Input()
	availableFiltersGeneric: genericFormInterface[] = [];

	@Input()
	mandatoryFilters: string[] = [];

	selectedFiltersIAC: iacOptionInterface[] = [];
	selectedFiltersGeneric: genericFormInterface[] = [];

	ngOnInit(): void {
		this.LabelsService.getLabels().subscribe((labels) => {
			this.labels = labels;
			this.isLoadingLabels = false;

			if (this.availableFiltersGeneric.length > 0 && this.availableFiltersIAC.length === 0) {
				this.availableFiltersIAC = this.convertFilterToIAC(this.availableFiltersGeneric);
			}

			for (const filter of this.availableFiltersGeneric) {
				if (this.mandatoryFilters.includes(filter.name)) {
					filter.required = true;
					filter.undeletable = true;

					this.setTag(`${filter.name},${filter.commonGroup}`);
				} else if (filter.selected == true) {
					this.setTag(`${filter.name},${filter.commonGroup}`);
				}
			}

			this.isLoadingFilters = false;
			this.isFirstRun = false;
		});
	}

	setTag(tagValue: string): void {
		for (let index = 0; index < this.availableFiltersGeneric.length; index++) {
			const filter = this.availableFiltersGeneric[index];
			if (tagValue === `${filter.name},${filter.commonGroup}`) {
				filter.selected = true;
				this.selectedFiltersGeneric.push(filter);
				this.availableFiltersIAC = this.convertFilterToIAC(this.availableFiltersGeneric);
				this.emitSelectedFilters();
				this.emitAddedTag();
				return;
			}
		}
	}

	deleteTag(tagIndex: number): void {
		this.selectedFiltersGeneric[tagIndex].values[0] = '';
		this.selectedFiltersGeneric[tagIndex].selected = false;

		this.selectedFiltersGeneric.splice(tagIndex, 1);
		this.availableFiltersIAC = this.convertFilterToIAC(this.availableFiltersGeneric);
		this.emitSelectedFilters();
	}

	resetTags(): void {
		for (let index = 0; index < this.selectedFiltersGeneric.length; index++) {
			this.deleteTag(index);
			index -= 1; //This is necessary because we are deleting one selected filter from the array each time
		}
	}

	convertFilterToIAC(genericForm: genericFormInterface[]): iacOptionInterface[] {
		const returnIAC: iacOptionInterface[] = [];
		for (const filter of genericForm) {
			if (filter.selected) continue;

			const newFilterIAC: iacOptionInterface = {
				name: this.labels[filter.label] ? this.labels[filter.label] : filter.name,
				value: `${filter.name},${filter.commonGroup}`,
				commonGroup: filter.commonGroup,
				tip: filter.tip,
			};

			returnIAC.push(newFilterIAC);
		}

		returnIAC.sort((a, b) => {
			if (a.name > b.name) return 1;
			if (a.name < b.name) return -1;
			return 0;
		});

		returnIAC.sort((a, b) => {
			if (a.commonGroup > b.commonGroup) return 1;
			if (a.commonGroup < b.commonGroup) return -1;
			return 0;
		});

		return returnIAC;
	}

	emitSelectedFilters(): void {
		if (this.isFirstRun) return;
		this.getFiltersIAC.emit(JSON.stringify(this.selectedFiltersIAC));
		this.getFilterGeneric.emit(JSON.stringify(this.selectedFiltersGeneric));
	}

	emitAddedTag(): void {
		if (this.isFirstRun) return;
		this.newTag.emit(true);
	}
}
